export default {
  "content": "<path d=\"M7 12c.26 0 .51-.1.71-.29l10-10L16.3.3 7 9.59 1.71 4.3.3 5.71l6 6c.19.19.44.29.7.29z\" fill=\"#ff00cb\" fill-opacity=\".3\"/>",
  "attrs": {
    "width": "18",
    "height": "12",
    "viewBox": "0 0 18 12",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};